var RepeaterArrayDataAdapter = require("enyo-ui/RepeaterArrayDataAdapter"),
    kind                     = require("enyo/kind");

require("enyo-ui");

/**
 * [RepeaterArrayDiffDataAdapter]{@link enyo-ui.RepeaterArrayDiffDataAdapter} is
 * designed to let [Repeater]{@link enyo-ui.Repeater} use an Array as data
 * source.
 *
 * It extends the standard adapter for array data, with the ability to diff
 * between old and new datasets.
 *
 * @class   enyo-ui.RepeaterArrayDiffDataAdapter
 * @extends enyo-ui.RepeaterArrayDataAdapter
 * @public
 */
module.exports = kind(/** @lends enyo-ui.RepeaterArrayDiffDataAdapter */ {

    /**
     * @public
     */
    name: "enyo-ui.RepeaterArrayDiffDataAdapter",

    /**
     * @public
     */
    kind: RepeaterArrayDataAdapter,

    /**
     * Whether the reaction to changes in data is paused.
     *
     * @type {bool}
     * @readonly
     * @public
     */
    isDataChangesPaused: false,

    /**
     * Temporarily stop reacting to changes in the dataset.
     *
     * @public
     */
    pauseDataChanges: function() {
        this.set("isDataChangesPaused", true);
    },

    /**
     * Resume reacting to changes in the dataset.
     *
     * @public
     */
    resumeDataChanges: function() {
        this.set("isDataChangesPaused", false);
    },

    /**
     * Cleans up any children that are no longer in the new dataset, then
     * triggers a new draw loop.
     *
     * @public
     */
    dataChanged: function() {
        var repeater = this.repeater,
            data;

        if (!this.isDataChangesPaused) {
            data = repeater.data || [];

            // First change properties derived from data
            repeater.set("length", data.length);

            // Then prune the DOM
            this.destroyObsoleteChildren();

            // Reflow the repeater, in case the arranger wants to do anything
            // predictive based on the new dataset.
            repeater.reflowOnDataChange && repeater.reflow();

            // Finally, update the DOM
            if (repeater.length && repeater.hasNode()) {
                repeater.draw();
            }
        }
    },

    /**
     * Iterates over indexed records and removes any children that are no longer
     * in the dataset.
     *
     * @public
     */
    destroyObsoleteChildren: function() {
        var repeater         = this.repeater,
            recordUidToChild = repeater.recordUidToChild,
            recordUid,
            record;

        repeater.stopDrawing();

        for (recordUid in recordUidToChild) {
            if (recordUidToChild.hasOwnProperty(recordUid)) {
                record = recordUidToChild[recordUid].data;

                if (this.getIndexByRecordUid(recordUid) === null) {
                    repeater.destroyChild(record);
                }
            }
        }
    },

    /**
     * Find the index of the record in the current dataset which has the same
     * requested uid.
     *
     * @param  {string}   recordUid  The record uid
     * @return {?number}  The index if found, `null` otherwise.
     */
    getIndexByRecordUid: function(recordUid) {
        var repeater = this.repeater,
            data     = repeater.data || [],
            index;

        index = data.findIndex(this.bindSafely(function(record) {
            return this.getRecordUid(record) === String(recordUid);
        }));

        return index > -1 ? index : null;
    },

    /**
     * This method simply re-applies the record if it's not the same as it was
     * before.
     *
     * @param  {enyo.Control}  child   The child
     * @param  {*}             record  The record
     * @return {enyo.Control}  The created child
     * @public
     */
    updateChild: function(child, record) {
        if (child.data !== record) {
            child.set("data", record);
        }

        return child;
    }

});
